import { PageHeader } from '@/components/layout/PageHeader'
import { site, socials } from '@/content/site'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import pageStyles from './Page.module.css'
import styles from './ContactPage.module.css'

export function ContactPage() {
  useDocumentTitle('Contact')

  return (
    <div className={pageStyles.page}>
      <PageHeader
        eyebrow="Contact"
        title="Get in touch"
        lede="The quickest way to reach me is email — but any of these work."
      >
        {site.availability && (
          <p className={styles.availability}>
            <span className={styles.availabilityDot} aria-hidden="true" />
            {site.availability}
          </p>
        )}
      </PageHeader>

      <ul className={styles.list}>
        {socials.map((social) => {
          const isMail = social.href.startsWith('mailto:')
          return (
            <li key={social.href}>
              <a
                className={styles.card}
                href={social.href}
                {...(isMail ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
              >
                <img src={social.icon} alt="" aria-hidden="true" loading="lazy" />
                <span className={styles.text}>
                  <span className={styles.label}>{social.label}</span>
                  {social.detail && <span className={styles.detail}>{social.detail}</span>}
                </span>
                <span className={styles.arrow} aria-hidden="true">
                  &rarr;
                </span>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
